import React from "react";

const EMOJIS = [
  "😀", "😂", "🙂", "😉", "😍", "😘", "😎", "🤔",
  "😐", "😴", "😢", "😭", "😡", "🥳", "🤯", "🤗",
  "👍", "👎", "👏", "🙏", "💪", "🤝", "👋", "✌️",
  "❤️", "🔥", "⭐", "✅", "❌", "🎉", "🎁", "☕",
  "🍕", "🍔", "🚀", "💻", "📱", "📌", "⏰", "💤",
];

const EmojiPicker = ({ onSelect }) => {
  return (
    <div className="emoji-picker">
      {EMOJIS.map((emoji) => (
        <button
          key={emoji}
          type="button"
          className="emoji-item"
          onClick={() => onSelect(emoji)}
        >
          {emoji}
        </button>
      ))}
    </div>
  );
};

export default EmojiPicker;
